import styled from 'styled-components';

import { colorCss, fontWeightCss, sizeCss } from 'lib/inquiryStyles';
import { TextComponentStyles } from 'lib/interfaces/ui-components';
import { fontFamilyCss } from 'verify/lib/utils/font-family';

export default styled.span<{ styles: TextComponentStyles }>(({ styles }) => ({
  // Layout styles
  marginTop: sizeCss(styles?.margin.base.base?.top) ?? 0,
  marginBottom: sizeCss(styles?.margin.base.base?.bottom) ?? 0,
  marginLeft: sizeCss(styles?.margin.base.base?.left) ?? 0,
  marginRight: sizeCss(styles?.margin.base.base?.right) ?? 0,
  // Text styles
  textAlign: styles?.['justify'].base.base,
  fontFamily: fontFamilyCss(styles?.['font-family'].base.base),
  fontSize: sizeCss(styles?.['font-size'].base.base),
  fontWeight: fontWeightCss(styles?.['font-weight'].base.base),
  letterSpacing: sizeCss(styles?.['letter-spacing'].base.base),
  lineHeight: sizeCss(styles?.['line-height'].base.base),
  color: colorCss(styles?.['text-color'].base.base),

  a: {
    color: colorCss(styles?.['text-color-highlight'].base.base),
    outlineColor: colorCss(styles?.['text-color-highlight'].base.base),
  },
}));
